module.exports = __webpack_public_path__ + "static/media/inplay-logo-iconSport.bb6548ae.svg";